<template>
    <div class="email-container container-fluid">
        <div class="row">
            <div class="col-12">
                <div class="card">
                    <div class="card-body">
                        <form
                            action=""
                            @submit="saveEmail"
                        >
                            <div class="form-group">
                                <label for="addresses">Addresses</label>
                                <select
                                    name="addresses"
                                    id="addresses"
                                    class="form-control"
                                    v-model="selectedEmail"
                                    @change="emailSelected"
                                    :disabled="sending || emailAddresses.length == 0"
                                >
                                    <option
                                        value=""
                                        disabled
                                    >
                                        Select email
                                    </option>
                                    <option
                                        v-for="(e, index) of emailAddresses"
                                        :value="e.value"
                                        :key="index"
                                    >
                                        {{ e.text }}
                                    </option>
                                </select>

                                <div
                                    class="alert alert-danger"
                                    v-if="emailAddressError"
                                >
                                    {{ emailAddressError }}
                                </div>
                            </div>
                            <div class="form-group">
                                <label for="to">To</label>
                                <input
                                    type="text"
                                    name="to"
                                    id="to"
                                    placeholder="name@example.com"
                                    v-model="email.to"
                                    class="form-control"
                                    :disabled="sending"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.to"
                                >{{ errors.to[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="from">From</label>
                                <input
                                    type="text"
                                    name="from"
                                    id="from"
                                    placeholder="me@example.com"
                                    v-model="email.from"
                                    class="form-control"
                                    :disabled="sending"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.from"
                                >{{ errors.from[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="subject">Subject</label>
                                <input
                                    type="text"
                                    name="subject"
                                    id="subject"
                                    placeholder="Subject..."
                                    v-model="email.subject"
                                    class="form-control"
                                    :disabled="sending"
                                >
                                <small
                                    class="form-error"
                                    v-if="errors.subject"
                                >{{ errors.subject[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label for="message">Message</label>
                                <textarea
                                    name="message"
                                    id="message"
                                    rows="10"
                                    v-model="email.message"
                                    class="form-control"
                                    :disabled="sending"
                                />
                                <small 
                                    class="form-error" 
                                    v-if="errors.message"
                                >{{ errors.message[0] }}</small>
                            </div>
                            <div 
                                class="form-group" 
                                v-if="email.attachments"
                            >
                                <label>Attachments</label>
                                <p v-if="email.attachments.length < 1">
                                    No attachments
                                </p>
                                <ul v-if="email.attachments.length > 0">
                                    <li 
                                        v-for="(attachment, index) in email.attachments" 
                                        :key="index"
                                    >
                                        <a 
                                            :href="attachment.file_url" 
                                            target="_blank"
                                        >{{ attachment.name }}</a>
                                    </li>
                                </ul>
                                <small 
                                    class="form-error" 
                                    v-if="errors.attachments"
                                >{{ errors.attachments[0] }}</small>
                            </div>
                            <div class="form-group">
                                <label 
                                    for="send_to_self" 
                                    v-if="usersEmail"
                                ><input 
                                    type="checkbox" 
                                    v-model="email.send_to_self" 
                                    id="send_to_self"
                                > Send a copy to myself ({{ usersEmail }})</label>
                            </div>
                            <div class="form-group">
                                <button 
                                    class="btn btn-primary" 
                                    type="button" 
                                    @click="sendEmail" 
                                    v-if="!sending && !email.sent_at"
                                >
                                    <i class="fa fa-paper-plane" /> Send
                                </button>
                                <button 
                                    class="btn btn-primary" 
                                    type="button" 
                                    @click="sendEmail" 
                                    v-if="!sending && email.sent_at"
                                >
                                    <i class="fa fa-paper-plane" /> Re-send
                                </button>
                                <button 
                                    class="btn btn-primary" 
                                    disabled 
                                    type="button" 
                                    v-if="sending"
                                >
                                    <i class="fa fa-spinner fa-spin" /> Sending
                                </button>
                                <button 
                                    class="btn btn-outline-danger" 
                                    type="button" 
                                    @click="deleteEmail" 
                                    v-if="email.id && !email.sent_at"
                                >
                                    <i class="fa fa-times" /> Delete
                                </button>
                                <router-link 
                                    class="btn btn-outline-info" 
                                    v-if="email.customer_id" 
                                    :to="{name: 'office.customers.show', params: {id: email.customer_id}}"
                                >
                                    View Customer
                                </router-link>
                                <span v-if="email.sent_at">Sent at {{ email.sent_at }}</span>
                                <span v-if="email.user">Last saved by {{ email.user.name }}</span>
                            </div>
                            <div
                                class="form-group"
                                v-if="userIsAdmin"
                            >
                                <router-link
                                    :to="{name: 'admin.settings'}"
                                    target="_blank"
                                >
                                    Edit Email Footer
                                </router-link> | <router-link
                                    :to="{name: 'admin.email_templates'}"
                                    target="_blank"
                                >
                                    Edit Email Templates
                                </router-link>
                            </div>
                        </form>
                        <div 
                            class="loading" 
                            v-if="loading"
                        >
                            <span>{{ loadingMessage }} <div class="fa fa-spinner fa-spin" /></span>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import AuthService from "../services/AuthService";
import CustomerService from "../services/CustomerService";
import EmailsService from "../services/EmailsService";
import FormService from "../services/FormService";
import EmailTemplatesService from "../services/EmailTemplatesService";
import SystemSettings from '../mixins/SystemSettings';

export default {
    mixins: [SystemSettings],
    data: function() {
        return {
            email: {},
            usersEmail: "",
            customer: {},
            errors: {},
            emailAddresses: [],
            selectedEmail: "",
            toAddresses: [],
            sending: false,
            loading: false,
            loadingMessage: "",
            user: null
        };
    },
    computed: {
        emailAddressError() {
            if (
                (this.customer.id && this.emailAddresses.length > 0) ||
                this.email.to
            ) {
                return null;
            } else {
                return "No email address for this customer, please obtain";
            }
        },

        userIsAdmin() {
            return this.user && this.user.admin_access;
        }
    },
    mounted: function() {
        this.resetForm();
        AuthService.getUser().then(user => {
            this.user = user;
            this.usersEmail = user.email;
        });
        this.email.from = this.sysSetting('email_from');
        if (this.$route.params.customer_id) {
            this.loadCustomer(this.$route.params.customer_id);
        }
        if (this.$route.params.id) {
            this.loadEmail(this.$route.params.id);
        }
        if (this.$route.query.form_id) {
            this.loadForm(this.$route.query.form_id);
        }
    },
    methods: {
        resetForm: function() {
            this.email = {
                to: "",
                from: this.usersEmail,
                subject: "",
                message: "",
                attachments: [],
                send_to_self: true,
                emailAddressError: null
            };
            this.errors = {};
        },
        loadCustomer: function(id) {
            CustomerService.get(id).then(res => {
                this.customer = res.data;
                this.email.customer_id = this.customer.id;
                if (this.customer.responsible_person_email) {
                    this.emailAddresses.push({
                        value: this.customer.responsible_person_email,
                        text:
                            "Responsible Person " +
                            this.customer.responsible_person_name +
                            " (" +
                            this.customer.responsible_person_email +
                            ")"
                    });
                }
                if (this.customer.billing_email) {
                    let text = "Billing ";
                    if (this.customer.billing_name) {
                        text += this.customer.billing_name;
                    }
                    text += " (" + this.customer.billing_email + ")";

                    this.emailAddresses.push({
                        value: this.customer.billing_email,
                        text: text
                    });
                }
                if (this.customer.sites) {
                    for (let site of this.customer.sites) {
                        if (site.email) {
                            this.emailAddresses.push({
                                value: site.email,
                                text:
                                    "Site " +
                                    site.name +
                                    " (" +
                                    site.email +
                                    ")"
                            });
                        }
                    }
                }

                if (this.emailAddresses.length > 0 && this.email.to === "") {
                    this.email.to = this.emailAddresses[0].value;
                }
            });
        },
        loadEmail: function(id) {
            this.loading = true;
            this.loadingMessage = "Loading email";
            EmailsService.get(id).then(
                res => {
                    this.email = res.data;
                    if (this.email.customer_id) {
                        this.loadCustomer(this.email.customer_id);
                    }
                    this.loading = false;
                },
                () => {
                    alert("Error: Could not load email");
                    this.loading = false;
                }
            );
        },
        saveEmail: function() {
            this.checkSaveEmailAddress();
            this.errors = {};
            this.loading = true;
            this.loadingMessage = "Saving email";
            EmailsService.updateOrCreate(this.email).then(
                res => {
                    this.email = res.data;
                    this.loading = false;
                    alert("Email saved");
                    this.$router.push({
                        name: "office.emails.edit",
                        params: { id: this.email.id }
                    });
                },
                err => {
                    alert("Error: Could not save email");
                    this.loading = false;
                    this.errors = err.response.data.errors;
                }
            );
        },
        sendEmail: function() {
            if (this.sending) {
                return;
            }
            this.checkSaveEmailAddress();
            this.sending = true;
            this.errors = {};
            EmailsService.send(this.email).then(
                res => {
                    this.email = res.data.email;
                    this.sending = false;
                    this.$router.push({
                        name: "office.emails.edit",
                        params: { id: this.email.id }
                    });
                    alert("Email sent to " + res.data.to.length + " addresses");
                    this.loadCustomer(this.email.customer_id);
                },
                err => {
                    this.sending = false;
                    alert("Error: Could not send email");
                    this.errors = err.response.data.errors;
                }
            );
        },
        deleteEmail: function() {
            const confirm = window.confirm(
                "Are you sure you want to delete this email?"
            );
            if (confirm) {
                EmailsService.delete(this.email).then(
                    () => {
                        alert("Email deleted");
                        this.resetForm();
                    },
                    () => {
                        alert("Error: Could not delete email");
                    }
                );
            }
        },

        loadForm: function(id) {
            this.loading = true;
            this.loadingMessage = "Creating attachment";
            FormService.makePDF(id).then(
                ({data}) => {
                    if (data.file_url) {
                        let attachment = {
                            ...data,
                            form_id: data.id,
                        };
                        this.email.attachments.push(attachment);
                        this.loadTemplate(data.type);
                        this.loading = false;
                    }
                },
                () => {
                    alert("Error: Could not load form");
                    this.loading = false;
                }
            );
        },

        loadTemplate: function(name) {
            this.loading = true;
            this.loadingMessage = "Loading email";
            EmailTemplatesService.search({ name: name }).then(
                res => {
                    if (res.data.length > 0) {
                        this.email.subject = res.data[0].subject;
                        this.email.message = res.data[0].content;
                        this.email.from = res.data[0].from;
                    } else {
                        alert("Error: Email template is not available");
                    }
                    this.loading = false;
                },
                () => {
                    alert("Error: Could not load email template");
                    this.loading = false;
                }
            );
        },

        emailSelected: function() {
            if (this.email.to.includes(this.selectedEmail)) {
                this.selectedEmail = "";
                return;
            }
            if (this.email.to !== "") {
                this.email.to += "; ";
            }
            this.email.to += this.selectedEmail;
            this.selectedEmail = "";
        },

        checkSaveEmailAddress() {
            if (!this.email.to) {
                return;
            }

            let emailAddress = this.email.to.split(",")[0].trim();

            if (!this.customer.billing_email) {
                let confirm = window.confirm(
                    `Save ${emailAddress} as customer's billing email address?`
                );
                if (confirm) {
                    this.customer.billing_email = emailAddress;
                    CustomerService.update(this.customer)
                        .then()
                        .catch(err => {
                            window.alert(
                                "Error: Failed saving customer billing address"
                            );
                            throw err;
                        });
                }
            }

            if (!this.customer.responsible_person_email) {
                let confirm = window.confirm(
                    `Save ${emailAddress} as customer's responsible person email address?`
                );
                if (confirm) {
                    this.customer.responsible_person_email = emailAddress;
                    CustomerService.update(this.customer)
                        .then()
                        .catch(err => {
                            window.alert(
                                "Error: Failed saving customer responsible person address"
                            );
                            throw err;
                        });
                }
            }
        }
    }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/EmailComponent.vue